import React from "react";
import { FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select } from "@material-ui/core"
import { Controller, useFormContext } from "react-hook-form"

const RHFSelect = ({ name, label, options = [], rules = {}, defaultValue }) => {
    const { control } = useFormContext();

    return (
        <Grid item xs={12}>
            <Controller name={name} control={control} rules={rules} render={({ field: { ref, ...field }, fieldState: { error } }) => (<FormControl fullWidth error={!!error}>
                <InputLabel>{label}</InputLabel>
                <Select {...field} defaultValue={defaultValue} inputRef={ref} labelId={name} label={label}>
                    {options.map((opt) => <MenuItem value={opt.value} key={opt.value}>{opt.label}</MenuItem>)}
                </Select>
                {error && error.message ? (
                    <FormHelperText>{error.message}</FormHelperText>
                ) : (
                    <></>
                )}
            </FormControl>)} />
        </Grid>
    )
}


export default RHFSelect;